import C from "action-types";

export const submitBackorderImport = data => {

  return {
    type: C.ORDERS.BACKORDER_IMPORT,
    payload: data
  }
};
